<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <ul class="grid grid-cols-3 gap-16 lg:grid-cols-4">
    <li
      v-for="metal in METALS"
      :key="metal.id"
      class="grid cursor-pointer place-items-center"
      @click="navigateToDetail(MODAL_ROUTES.METAL_LIBRARY, metal.slug)"
    >
      <MetalImage :metal :size="72" />
      <p class="raw-cta-3 text-center !leading-[1.25]">
        {{ i18n(metal.name) }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import MetalImage from '~/scopes/campaign/components/UI/MetalImage.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import { MODAL_ROUTES } from '~/scopes/campaign/const/config.const'
import { METALS } from '~/scopes/campaign/data/metals/data'

const i18n = useI18n()
const { navigateToDetail } = useModalState()
</script>

<style scoped>
li {
  padding: 0.5rem;
  border-radius: 0.75rem;
  background-color: color-mix(in oklab, white 25%, transparent);

  @media (hover: hover) {
    transition: background-color var(--raw-out-quart);

    :deep(img) {
      transition: transform var(--raw-out-quart);
    }

    &:hover {
      background-color: color-mix(in oklab, white, transparent);

      :deep(img) {
        transform: scale(108%) rotate(-3deg);
      }
    }
  }
}
</style>
